<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="GoogleCalendar" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { GoogleCalendarProps } from './GoogleCalendar.ts';
import GoogleCalendar from './GoogleCalendar.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';
import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-google-calendar';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<GoogleCalendarProps>();
const changableProps = useChangableProps(componentName, props);
</script>
